import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { hubspotTrackEvent } from '@marvelapp/core';
import { useCurrentUser } from '@marvelapp/marvel-3-application';
import { Semibold } from '@marvelapp/ui';
import ConfettiSuccessMessage from '../ConfettiSuccessMessage';
import LimitMessage from './LimitMessage';
const HUBSPOT_FORM_ID = 'f4d82fcc-a95a-41e5-adcd-239e9510d408';
const TEAM_SIZE_SELF_SERVE_LIMIT_REACHED = '000006651085';
export default function TeamAllowanceLimitMessage({ userType }) {
    const history = useHistory();
    const user = useCurrentUser();
    const [currentPage, setCurrentPage] = useState('limitMessage');
    const [isSending, setIsSending] = useState(false);
    hubspotTrackEvent(TEAM_SIZE_SELF_SERVE_LIMIT_REACHED);
    const { username, email, company: { name: companyName }, } = user;
    const postData = {
        name: username,
        hubspotFormId: HUBSPOT_FORM_ID,
        formName: 'Request Quote Team Limit Hit Page',
        email,
        companyName,
        referrer: document.referrer,
        hutk: readCookie('hubspotutk'),
        usersRequired: '7-9',
    };
    return currentPage === 'limitMessage' ? (React.createElement(LimitMessage, { goToSuccessScreen: () => setCurrentPage('successScreen'), isSendingSubmission: isSending, postData: postData, setIsSendingSubmission: setIsSending, userType: userType })) : (React.createElement(ConfettiSuccessMessage, { heading: "We'll be in touch soon by email", onButtonClick: () => history.replace('/'), text: React.createElement(React.Fragment, null,
            "Keep an eye on ",
            React.createElement(Semibold, null, email),
            " inbox for more details.") }));
}
function readCookie(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}
